import { Container, Grid } from "@mui/material";
import ScreenBanner from "../../components/ScreenBanner";
import ListaAcoesRapidas, { TItemAcaoRapida } from "../../components/ListaAcoesRapidas";
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import CardDadosDashboard from "./components/CardDadosDashboard";
import { useNavigate } from "react-router";
import { IDataResumoTitulosPagar } from "../../types/api/financeiro/resumo-titulos-pagar";
import { IDataResumoTitulosReceber } from "../../types/api/financeiro/resumo-titulos-receber";
import { useCallback, useEffect, useState } from "react";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import SolicitarAnaliseCredito from "./components/SolicitarAnaliseCredito";
import { enqueueSnackbar } from "notistack";
import CardEstatisticasFluxo from "./components/MIDashboard/EstatisticasFluxo";
import CardFluxoCaixa from "./components/MIDashboard/CardFluxoCaixa";
import { useModalDetalheProcesso } from "../../components/ModalContexts/ModalDetalheProcessoContext";
import PermissionGuard, { usePermission } from "../../components/PermissionGuard";

export default function Financeiro() {

    const navigate = useNavigate();
    const { openModal } = useModalDetalheProcesso()

    const [modais, setModais] = useState({
        solicitarAnaliseCredito: false
    });

    const [processo, setProcesso] = useState<string | null>(null)

    //Funções Manipuladoras
    const handleToggleModal = useCallback((prop: "solicitarAnaliseCredito", value: boolean) => {
        setModais(prevState => ({
            ...prevState,
            [prop]: value
        }))
    }, [])
    //

    const listaAcoesRapidas: Array<TItemAcaoRapida> = [
        {
            label: "Solicitar análise de crédito",
            icon: <MonetizationOnIcon color="primary" />,
            action: () => handleToggleModal("solicitarAnaliseCredito", true),
            havePermission: usePermission("financeiro.limite-credito"),
        },
        {
            label: "Analisar solicitações de crédito",
            icon: <PaidOutlinedIcon color="primary" />,
            action: () => navigate('/financeiro/limite-credito/lista-todas'),
            havePermission: usePermission("financeiro.limite-credito-listar")
        },
        {
            label: "Títulos a receber",
            icon: <RequestQuoteOutlinedIcon color="primary" />,
            action: () => navigate("/financeiro/contas-receber/listar-todas"),
            havePermission: usePermission("financeiro.listar-titulo-receber")
        },
        {
            label: "Títulos a pagar",
            icon: <CreditCardOutlinedIcon color="primary" />,
            action: () => navigate("/financeiro/contas-pagar/listar-todas"),
            havePermission: usePermission("financeiro.listar-titulo-pagar")
        }
    ]

    useEffect(() => {
        if (processo) {
            openModal(processo)
            setProcesso(null)
        }
    }, [processo])

    return (
        <>
            <ScreenBanner title="Financeiro" />
            <PermissionGuard permissionId="financeiro.dashboard">
                <Container>
                    <Grid container spacing={2} mt={2}>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <ListaAcoesRapidas
                                items={listaAcoesRapidas}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 8 }}>
                            <CardDadosDashboard />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <CardEstatisticasFluxo />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <CardFluxoCaixa />
                        </Grid>
                    </Grid>
                </Container>

                {
                    modais.solicitarAnaliseCredito &&
                    <>
                        <SolicitarAnaliseCredito
                            handleChangeProcesso={(item: string) => setProcesso(item)}
                            open={modais.solicitarAnaliseCredito}
                            handleClose={() => {
                                handleToggleModal("solicitarAnaliseCredito", false)
                            }}
                            onCreate={(codigo: string) => {
                                handleToggleModal("solicitarAnaliseCredito", false)
                                enqueueSnackbar(`Solicitação de análise de crédito #${codigo} foi criada com sucesso!`, { variant: "success" })
                            }}
                            onFail={() => {
                                enqueueSnackbar(`Erro ao criar solicitação de análise de crédito`, { variant: "error" })
                            }}
                        />
                    </>
                }
            </PermissionGuard>


        </>
    )
}

export type TOpcoesVisualizacao = "Por público" | "Por função" | "Por departamento"

export const coresTabelas = {
    vencidos: "rgba(255, 68, 68, 0.07)",
    paraVencer: "rgba(0, 85, 64, 0.09)"
}

export const mostrarDadoPrimario = (titulo: IDataResumoTitulosPagar | IDataResumoTitulosReceber, visualizacao: TOpcoesVisualizacao) => {
    if (visualizacao === "Por função") return titulo.funcao
    if (visualizacao === "Por departamento") return titulo.departamento
    if (visualizacao === "Por público") return inserirNomePublico(titulo.publico)

    return ""
}

export const inserirNomePublico = (str: string): string => {
    let resultado = ""

    switch (str) {
        case "A":
            resultado = "Associado"
            break
        case "C":
            resultado = "Cliente"
            break
        case "E":
            resultado = "Empregado"
            break
        case "F":
            resultado = "Fornecedor"
            break
        default:
            resultado = str
            break
    }

    return resultado
}